import cloneDeep from 'lodash/cloneDeep'

type BaseEntity = {
  id?: number,
}

export const mergeAndStringifyEntityObjects = <Entity extends BaseEntity, EntityParams>(
  entity: Entity,
  entityParams: EntityParams,
  entityObjectKeys: (keyof Entity | keyof EntityParams)[] = [],
  entityArrayKeys: (keyof Entity | keyof EntityParams)[] = [],
): Entity & EntityParams => {
  const updatedEntityParams = {
    id: entity.id,
    ...entityParams,
  }

  entityObjectKeys.forEach((key) => {
    const entityObject = entity[key] || {}
    const entityParamsObject = entityParams[key] || {}

    updatedEntityParams[key] = JSON.stringify({
      ...cloneDeep(entityObject),
      ...entityParamsObject,
    })
  })

  entityArrayKeys.forEach((key) => {
    const entityParamsArray = entityParams[key] || []
    updatedEntityParams[key] = JSON.stringify(entityParamsArray)
  })

  return updatedEntityParams
}

export default mergeAndStringifyEntityObjects
